export enum apiUrlCategories {
    CATEGORY_LEVEL_ONE = '/v1/category-level1/',
    CATEGORY_LEVEL_TWO = '/v1/category-level2/',
    CATEGORY_LEVEL_THREE = '/v1/category-level3/',
    CATEGORY_LEVEL_THREE_HEADING = '/v1/category-level3-heading/',
}
